import axios from 'axios';
import { setHeaders } from './headers.mjs';
import { API_BASE_URLS } from './config.mjs'; // Ensure correct import
import { store } from '../store/store.js';
import { authenticateActions } from "../store/store.js";
import { adminServiceAPI } from '../api/axiosInstance.js'

adminServiceAPI.interceptors.response.use(
  (response) => response, // If success, just return the response
  (error) => {
    const message = error?.response?.data?.message;

    if (
      message === "Invalid or expired access token" ||
      message === "Invalid or Missing AccessToken"
    ) {
      store.dispatch(authenticateActions.logout());
      localStorage.removeItem("refreshToken");
      window.location.href = "/login";
    }

    // Always return or reject the error to keep the chain working
    return Promise.reject(error);
  }
);

const proxyRequest = async (service, endpoint, method, body = {}) => {
  try {
    const targetURL = `${API_BASE_URLS[service]}${endpoint}`;
    console.log('✅ Target URL:', targetURL);

    // Ensure the endpoint is passed correctly
    if (!endpoint) {
      throw new Error('Endpoint is required!');
    }

    // Set headers with the token and custom headers
    const headers = setHeaders(true, "napid_auth");
    const requestData = method === 'GET' ? {} : { endpoint, ...body }; // For GET requests, leave body empty
    const response = await adminServiceAPI({
      method: method,
      url: '/admin', // This is the default API endpoint for proxy requests
      params: method === 'GET' ? { endpoint } : {},  // Pass `endpoint` as query param for GET
      headers: headers,
    });
    return response.data;
  } catch (error) {
    if (
      error.response.data.statusCode === "FAILED" &&
      error.response.data.message === "Invalid or expired access token"
    ) {
      window.location.href = "/login"; // Redirect to login page
    }

    return error.response.data;
  }
};

const proxyRequestReports = async (service, endpoint, method, body = {}, userId = null, token = null) => {

  try {
    const targetURL = `${API_BASE_URLS[service]}${endpoint}`;
    console.log('✅ Target URL:', targetURL);
    if (!endpoint) {
      throw new Error('Endpoint is required!');
    }

    const headers = setHeaders(true, "napid_auth");
    const requestData = method === 'GET' ? {} : { endpoint, ...body };
    const response = await adminServiceAPI({
      method: method,
      url: '/admin',
      params: method === 'GET' ? { endpoint } : {},
      responseType: 'blob',
      headers: headers,
    });
    return response;

  } catch (error) {

    if (
      error.response.data.statusCode === "FAILED" &&
      error.response.data.message === "Invalid or expired access token"
    ) {
      window.location.href = "/login";
    }

    return error.response.data;
  }
};

export const AdminAPI = {

  getApplications: async () => {
    const endpoint = '/adminreportservice/v1/application/all';
    return proxyRequest('ADMIN_SERVICE', endpoint, 'GET', null, null, null, 'napid_auth');
  },

  fetchHomepageData: async () => {
    const endpoint = '/adminreportservice/v1/homepage';
    return proxyRequest('ADMIN_SERVICE', endpoint, 'GET', null, null, null, 'napid_auth');
  },

  fetchApplicationMessages: async () => {
    const endpoint = '/adminreportservice/v1/adminreport/all/jstext';
    return proxyRequest('ADMIN_SERVICE', endpoint, 'GET', null, null, null, 'napid_auth');
  },


  fetchApplications: async () => {
    const endpoint = '/adminreportservice/v1/application/transactiontime/all';
    return proxyRequest('ADMIN_SERVICE', endpoint, 'GET', null, null, null, 'napid_auth');
  },

  fetchApplicationsjs: async () => {
    const endpoint = '/adminreportservice/v1/application/jslogo/all ';
    return proxyRequest('ADMIN_SERVICE', endpoint, 'GET', null, null, null, 'napid_auth');
  },

  fetchApplicationReport2: async () => {
    const endpoint = '/adminreportservice/v1/application/all';
    return proxyRequest('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },

  fetchTransactionHistory: async (applicationId, fromDateValue, toDateValue, pages, size) => {
    const endpoint = `/adminreportservice/v1/alltransactionhistory/applicationid/${applicationId}/${fromDateValue}/${toDateValue}/${pages}/${size}`;
    return proxyRequest('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },

  fetchUserData: async (applicationId, fromDateValue, toDateValue, page, size) => {
    const endpoint = `/adminreportservice/v1/allcustomerdata/applicationid/${applicationId}/${fromDateValue}/${toDateValue}/${page}/${size}`;
    return proxyRequest('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },
  fetchNonCustomerData: async (applicationId, fromDateValue, toDateValue, nonCustomerpages, size) => {
    const endpoint = `/adminreportservice/v1/noncustomer/transactionhistory/applicationid/${applicationId}/${fromDateValue}/${toDateValue}/${nonCustomerpages}/${size}`;
    return proxyRequest('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },

  generateTransactionHistoryPDF: async (applicationid, fromDate, toDate) => {
    const endpoint = `/adminreportservice/v1/generatepdf/searchbytransactionhistory/${applicationid}/${fromDate}/${toDate}`;
    return proxyRequestReports('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },
  generateTransactionHistoryExcel: async (applicationid, fromDate, toDate) => {
    const endpoint = `/adminreportservice/v1/excelformat/searchbytransactionhistory/${applicationid}/${fromDate}/${toDate}`;
    return proxyRequestReports('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },
  generateUserDataPDF: async (applicationid, fromDate, toDate) => {
    const endpoint = `/adminreportservice/v1/generatepdf/searchbycustomerdata/${applicationid}/${fromDate}/${toDate}`;
    return proxyRequestReports('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },
  generateNonCustomerPDF: async (applicationid, fromDate, toDate) => {
    const endpoint = `/adminreportservice/v1/generatepdf/noncustomer/transactionhistory/${applicationid}/${fromDate}/${toDate}`;
    return proxyRequestReports('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },
  generateUserDataExcel: async (applicationid, fromDate, toDate) => {
    const endpoint = `/adminreportservice/v1/excelformat/searchbycustomerdata/${applicationid}/${fromDate}/${toDate}`;
    return proxyRequestReports('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },
  generateNonCustomerExcel: async (applicationid, fromDate, toDate) => {
    const endpoint = `/adminreportservice/v1/excelformat/noncustomer/transactionhistory/${applicationid}/${fromDate}/${toDate}`;
    return proxyRequestReports('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },

  getMobileNumberPdf: async (mobileNo, applicationid, fromdate, todate) => {
    const endpoint = `/adminreportservice/v1/generatepdf/searchbymobileno/${mobileNo}/${applicationid}/${fromdate}/${todate}`;
    return proxyRequestReports('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },
  getMobileNumberExcel: async (mobileNo, applicationid, fromdate, todate) => {
    const endpoint = `/adminreportservice/v1/excelformat/searchbymobileno/${mobileNo}/${applicationid}/${fromdate}/${todate}`;
    return proxyRequestReports('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },

  getMobileDetails: async (mobileNo, pageno, size) => {
    const endpoint = `/adminreportservice/v1/searchbymobileno/mobileuser/${mobileNo}/${pageno}/${size}`;
    return proxyRequest('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },
  getMobilePdf: async (mobileNo) => {
    const endpoint = `/adminreportservice/v1/generatepdf/searchbymobileno/${mobileNo}`;
    return proxyRequestReports('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },
  getMobileExcel: async (mobileNo) => {
    const endpoint = `/adminreportservice/v1/excelformat/searchbymobileno/${mobileNo}`;
    return proxyRequestReports('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },
  getApplicationReports: async () => {
    const endpoint = `/adminreportservice/v1/allapplication`;
    return proxyRequest('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },
  getIdCardNumberEmail: async (digitalid, applicationid, fromdate, todate, page, size) => {
    const endpoint = `/adminreportservice/v1/searchbyid/${digitalid}/${applicationid}/${fromdate}/${todate}/${page}/${size}`;
    return proxyRequest('ADMIN_SERVICE', endpoint, 'GET', null, null, null);

  },
  getIdCardNumberEmailTransaction: async (digitalid, applicationid, fromdate, todate, page, size) => {
    const endpoint = `/adminreportservice/v1/searchbyid/transaction/${digitalid}/${applicationid}/${fromdate}/${todate}/${page}/${size} `;
    return proxyRequest('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },
  getMobileNumber: async (mobileno, applicationid, fromdate, todate, page, size) => {
    const endpoint = `/adminreportservice/v1/searchbymobilenumber/${mobileno}/${applicationid}/${fromdate}/${todate}/${page}/${size}`;
    return proxyRequest('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },

  getMobileNumberTransaction: async (mobileno, applicationid, fromdate, todate, page, size) => {
    const endpoint = `/adminreportservice/v1/searchbymobilenumber/transaction/${mobileno}/${applicationid}/${fromdate}/${todate}/${page}/${size}`;
    return proxyRequest('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },
  getCountryCode: async () => {
    const endpoint = `/adminreportservice/v1/allcountrycode`;
    return proxyRequest('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },
  getIdPdf: async (digitalid, applicationid, fromdate, todate) => {
    const endpoint = `/adminreportservice/v1/generatepdf/searchbydigitalid/${digitalid}/${applicationid}/${fromdate}/${todate}`;
    return proxyRequestReports('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },
  getIdPdfTransaction: async (digitalid, applicationid, fromdate, todate) => {
    const endpoint = `/adminreportservice/v1/generatepdf/searchbydigitalid/transaction/${digitalid}/${applicationid}/${fromdate}/${todate}`;
    return proxyRequestReports('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },
  getMobileNumberPdfTransaction: async (mobileNo, applicationid, fromdate, todate) => {
    const endpoint = `/adminreportservice/v1/generatepdf/searchbymobileno/transaction/${mobileNo}/${applicationid}/${fromdate}/${todate}`;
    return proxyRequestReports('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },
  getMobileNumberExcelTransaction: async (mobileNo, applicationid, fromdate, todate) => {
    const endpoint = `/adminreportservice/v1/excelformat/searchbymobileno/transaction/${mobileNo}/${applicationid}/${fromdate}/${todate}`;
    return proxyRequestReports('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },
  getIdExcelTransaction: async (digitalid, applicationid, fromdate, todate) => {
    const endpoint = `/adminreportservice/v1/excelformat/searchbydigitalid/transaction/${digitalid}/${applicationid}/${fromdate}/${todate}`;
    return proxyRequestReports('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },
  getIdExcel: async (digitalid, applicationid, fromdate, todate) => {
    const endpoint = `/adminreportservice/v1/excelformat/searchbydigitalid/${digitalid}/${applicationid}/${fromdate}/${todate}`;
    return proxyRequestReports('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },
  getIdCardNumberEmailAdmin: async (digitalid, applicationid, fromdate, todate, page, size) => {
    const endpoint = `/adminreportservice/v1/admin/searchbyid/${digitalid}/${applicationid}/${fromdate}/${todate}/${page}/${size}`;
    return proxyRequest('ADMIN_SERVICE', endpoint, 'GET', null, null, null);

  },
  getIdCardNumberEmailTransactionAdmin: async (digitalid, applicationid, fromdate, todate, page, size) => {
    const endpoint = `/adminreportservice/v1/admin/searchbyid/transaction/${digitalid}/${applicationid}/${fromdate}/${todate}/${page}/${size}`;
    return proxyRequest('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },
  getMobileNumberAdmin: async (mobileno, applicationid, fromdate, todate, page, size) => {
    const endpoint = `/adminreportservice/v1/admin/searchbymobilenumber/${mobileno}/${applicationid}/${fromdate}/${todate}/${page}/${size}`;
    return proxyRequest('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },
  getMobileNumberTransactionAdmin: async (mobileno, applicationid, fromdate, todate, page, size) => {
    const endpoint = `/adminreportservice/v1/admin/searchbymobilenumber/transaction/${mobileno}/${applicationid}/${fromdate}/${todate}/${page}/${size}`;
    return proxyRequest('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },
  getIdPdfAdmin: async (digitalid, applicationid, fromdate, todate) => {
    const endpoint = `/adminreportservice/v1/admin/generatepdf/searchbydigitalid/${digitalid}/${applicationid}/${fromdate}/${todate}`;
    return proxyRequestReports('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },

  getIdPdfTransactionAdmin: async (digitalid, applicationid, fromdate, todate) => {
    const endpoint = `/adminreportservice/v1/admin/generatepdf/searchbydigitalid/transaction/${digitalid}/${applicationid}/${fromdate}/${todate}`;
    return proxyRequestReports('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },
  getMobileNumberPdfAdmin: async (mobileNo, applicationid, fromdate, todate) => {
    const endpoint = `/adminreportservice/v1/admin/generatepdf/searchbymobileno/${mobileNo}/${applicationid}/${fromdate}/${todate}`;
    return proxyRequestReports('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },
  getMobileNumberPdfTransactionAdmin: async (mobileNo, applicationid, fromdate, todate) => {
    const endpoint = `/adminreportservice/v1/admin/generatepdf/searchbymobileno/transaction/${mobileNo}/${applicationid}/${fromdate}/${todate}`;
    return proxyRequestReports('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },
  fetchTransactionHistoryAdmin: async (applicationId, fromDateValue, toDateValue, pages, size) => {
    const endpoint = `/adminreportservice/v1/admin/alltransactionhistory/applicationid/${applicationId}/${fromDateValue}/${toDateValue}/${pages}/${size}`;
    return proxyRequest('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },
  fetchUserDataAdmin: async (applicationId, fromDateValue, toDateValue, page, size) => {
    const endpoint = `/adminreportservice/v1/admin/allcustomerdata/applicationid/${applicationId}/${fromDateValue}/${toDateValue}/${page}/${size}`;
    return proxyRequest('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },
  generateUserDataPDFAdmin: async (applicationid, fromDate, toDate) => {
    const endpoint = `/adminreportservice/v1/admin/generatepdf/searchbycustomerdata/${applicationid}/${fromDate}/${toDate}`;
    return proxyRequestReports('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },
  generateTransactionHistoryPDFAdmin: async (applicationid, fromDate, toDate) => {
    const endpoint = `/adminreportservice/v1/admin/generatepdf/searchbytransactionhistory/${applicationid}/${fromDate}/${toDate}`;
    return proxyRequestReports('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },
  getMobileDetailsAdmin: async (mobileNo, pageno, size) => {
    const endpoint = `/adminreportservice/v1/admin/searchbymobileno/mobileuser/${mobileNo}/${pageno}/${size}`;
    return proxyRequest('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },
  getMobilePdfAdmin: async (mobileNo) => {
    const endpoint = `/adminreportservice/v1/admin/generatepdf/searchbymobileno/${mobileNo}`;
    return proxyRequestReports('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },
  generateTransactionHistoryExcelAdmin: async (applicationid, fromDate, toDate) => {
    const endpoint = `/adminreportservice/v1/admin/excelformat/searchbytransactionhistory/${applicationid}/${fromDate}/${toDate}`;
    return proxyRequestReports('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },
  generateUserDataExcelAdmin: async (applicationid, fromDate, toDate) => {
    const endpoint = `/adminreportservice/v1/admin/excelformat/searchbycustomerdata/${applicationid}/${fromDate}/${toDate}`;
    return proxyRequestReports('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },
  getMobileNumberExcelAdmin: async (mobileNo, applicationid, fromdate, todate) => {
    const endpoint = `/adminreportservice/v1/admin/excelformat/searchbymobileno/${mobileNo}/${applicationid}/${fromdate}/${todate}`;
    return proxyRequestReports('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },
  getMobileExcelAdmin: async (mobileNo, role) => {
    const endpoint = `/adminreportservice/v1/admin/excelformat/searchbymobileno/${mobileNo}`;
    return proxyRequestReports('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },
  getMobileNumberExcelTransactionAdmin: async (mobileNo, applicationid, fromdate, todate) => {
    const endpoint = `/adminreportservice/v1/admin/excelformat/searchbymobileno/transaction/${mobileNo}/${applicationid}/${fromdate}/${todate}`;
    return proxyRequestReports('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },
  getIdExcelTransactionAdmin: async (digitalid, applicationid, fromdate, todate) => {
    const endpoint = `/adminreportservice/v1/admin/excelformat/searchbydigitalid/transaction/${digitalid}/${applicationid}/${fromdate}/${todate}`;
    return proxyRequestReports('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },
  getIdExcelAdmin: async (digitalid, applicationid, fromdate, todate) => {
    const endpoint = `/adminreportservice/v1/admim/excelformat/searchbydigitalid/${digitalid}/${applicationid}/${fromdate}/${todate}`;
    return proxyRequestReports('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },
  getSecuredOptedIds: async (fromdate, todate, page, size) => {
    const endpoint = `/adminreportservice/v1/report/optedin/customer/${fromdate}/${todate}/${page}/${size}`;
    return proxyRequest('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },
  getSecuredOptedIdsPdf: async (fromDateValue, toDateValue) => {
    console.log("Received fromDate:", fromDateValue);
    console.log("Received toDate:", toDateValue); // Log the received value
    const endpoint = `/adminreportservice/v1/report/generatepdf/optedin/customer/${fromDateValue}/${toDateValue}`;
    return proxyRequestReports('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },
  getSecuredOptedIdsExcel: async (fromDateValue, toDateValue) => {
    const endpoint = `/adminreportservice/v1/report/excelformat/optedin/customer/${fromDateValue}/${toDateValue}`;
    return proxyRequestReports('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },
  getMonthlyBillingPdf: async (month, year) => {
    const endpoint = `/adminreportservice/v1/report/generatepdf/monthly/customer/${month}/${year}`;
    return proxyRequestReports('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },
  getMonthlyBillingExcel: async (month, year) => {
    const endpoint = `/adminreportservice/v1/report/excelformat/monthly/customer/${month}/${year}`;
    return proxyRequestReports('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },
  getRenewalHistory: async (userId, serviceId) => {
    const endpoint = `/adminreportservice/v1/report/renewal/history/${userId}/${serviceId}`;
    return proxyRequest('ADMIN_SERVICE', endpoint, 'GET', null, null, null);

  },
  getRenewalHistoryPdf: async (userId, serviceId) => {
    const endpoint = `/adminreportservice/v1/report/renewal/history/generatepdf/${userId}/${serviceId}`;
    return proxyRequestReports('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },
  getRenewalHistoryExcel: async (userId, serviceId) => {
    const endpoint = `/adminreportservice/v1/report/renewal/history/excelformat/${userId}/${serviceId}`;
    return proxyRequestReports('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },
  getMobilenumberUpdationList: async (serviceId, userId) => {
    const endpoint = `/adminreportservice/v1/report/mobileno/history/${serviceId}/${userId}`;
    return proxyRequest('ADMIN_SERVICE', endpoint, 'GET', null, null, null);

  },
  getMobileNumberupdationPdf: async (serviceId, userId) => {
    const endpoint = `/adminreportservice/v1/report/mobileno/history/generatepdf/${serviceId}/${userId}`;
    return proxyRequestReports('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },

  getMobileNumberupdationExcel: async (serviceId, userId) => {
    const endpoint = `/adminreportservice/v1/report/mobileno/history/excelformat/${serviceId}/${userId}`;
    return proxyRequestReports('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  },

  getTwoFaReport: async (month, year) => {
    const endpoint = `/adminreportservice/v1/reports/2fa/billing/monthly/${month}/${year}/export`;
    return proxyRequestReports('ADMIN_SERVICE', endpoint, 'GET', null, null, null);
  }
};

export default AdminAPI;
